__turbopack_context__.v({
  "container": "styles-module__SIb4LG__container",
  "footer": "styles-module__SIb4LG__footer",
  "header": "styles-module__SIb4LG__header",
  "hidden": "styles-module__SIb4LG__hidden",
  "optional": "styles-module__SIb4LG__optional",
  "titleWrapper": "styles-module__SIb4LG__titleWrapper",
  "tooltip": "styles-module__SIb4LG__tooltip",
});
